<template>
  <div class="bootcamp-home" v-if="isFeaturedBootcampShown">
    <div
      v-if="shouldSeeCta && !isContentLoading"
      class="bootcamp-home__subs-advise"
    >
      <div class="bootcamp-home__wrapper bootcamp-home__header">
        <img
          src="@/assets/images/home/INEBootcamps.png"
          alt="INE Bootcamp"
          class="bootcamp-home__header-img"
        />
        <div class="bootcamp-home__header-title">
          Available to Premium and <br />
          Business Subscribers free of charge.
        </div>
        <a
          :href="`//${plansLink}`"
          class="btn btn--primary bootcamp-home__header--cta"
        >
          See plans
        </a>
      </div>
    </div>
    <div
      class="bootcamp-home__wrapper bootcamp-home__spinner-wrapper"
      v-if="isContentLoading"
    >
      <ActionLoader loaderClass="bootcamp-home__spinner" />
    </div>
    <div v-else class="bootcamp-home__content">
      <div class="bootcamp-home__feature" v-if="featureBootcamp">
        <div class="bootcamp-home__wrapper">
          <FeatureHomeBootcamp
            :bootcamp="featureBootcamp"
            :bootcampTextHeader="currentOrNext"
            :isMobile="isMobile"
          />
        </div>
      </div>
      <div
        class="bootcamp-home__next bootcamp-home__wrapper"
        v-if="upcomingBootcamps && upcomingBootcamps.length"
      >
        <UpcomingBootcamps
          :bootcamps="upcomingBootcamps"
          :isMobile="isMobile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import FeatureHomeBootcamp from '@/components/home/subscriber-view/bootcamps-section/FeatureHomeBootcamp.vue'
import UpcomingBootcamps from '@/components/home/subscriber-view/bootcamps-section/UpcomingBootcamps.vue'

export default {
  components: {
    ActionLoader,
    FeatureHomeBootcamp,
    UpcomingBootcamps,
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      isContentLoading: false,
    }
  },
  computed: {
    ...mapState({
      plansLink: state => state.app.plansLink,
    }),
    ...mapGetters({
      isBusinessUser: 'auth/isBusinessUser',
      next: 'bootcamps/next',
      upcoming: 'bootcamps/upcoming',
      current: 'bootcamps/current',
      usersSubscriptions: 'subscriptions/usersSubscriptions',
    }),
    isFeaturedBootcampShown() {
      const showBootcamp =
        this.isContentLoading ||
        this.featureBootcamp !== null ||
        (this.upcomingBootcamps && this.upcomingBootcamps.length)
      this.$emit('isFeaturedBootcampShown', showBootcamp)
      return showBootcamp
    },
    featureBootcamp() {
      if (this.current.length) {
        return this.current[0]
      }
      return this.next
    },
    upcomingBootcamps() {
      if (this.current.length) {
        if (this.next) {
          return [this.next, ...this.upcoming]
        }
        return this.upcoming
      }
      return this.upcoming
    },
    currentOrNext() {
      return this.current.length ? 'Happening now' : 'Next Bootcamp'
    },
    hasPremiumPlan() {
      const found = this.usersSubscriptions.activePlans.find(plan => {
        const { plan_code } = plan
        return plan_code && CONSTANTS.PLANS.PREMIUM_PLANS.includes(plan_code)
      })
      return !!found
    },
    shouldSeeCta() {
      return !this.isBusinessUser && !this.hasPremiumPlan
    },
  },
  async created() {
    this.isContentLoading = true
    await this.$store.dispatch('bootcamps/getCurrentBootcamps')
    this.isContentLoading = false
  },
}
</script>

<style lang="scss" scoped>
.bootcamp-home {
  $this: &;
  background: var(--darker-gray);
  color: var(--white);
  padding: 15px 20px 60px 20px;
  margin-top: 62px;
  @include mobile {
    margin-top: 0;
    padding: 0 50px 60px 50px;
    z-index: 10;
    position: relative;
  }
  @include desktop {
    z-index: 0;
    padding: 0 220px 60px 220px;
  }
  &__content {
    max-width: 1000px;
    margin: auto;
  }
  &__spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 600px;
  }
  &__wrapper {
    width: 100%;
  }
  &__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    @include mobile {
      flex-direction: row;
      justify-content: initial;
      padding: 15px 20px;
    }
    &--cta {
      width: 100%;
      height: 36px;
      font-size: rem(14px);
      line-height: 20px;
      @include mobile {
        width: fit-content;
        height: 47px;
        font-size: rem(16px);
        line-height: 23px;
      }
    }
    &-img {
      margin-bottom: 5px;
      max-width: 220px;
      @include mobile {
        max-width: 165px;
        margin-bottom: 0;
      }
    }
    &-title {
      font-size: rem(14px);
      line-height: 20px;
      text-align: center;
      color: var(--light-blue-gray);
      margin-bottom: 20px;
      @include mobile {
        flex: 1 0;
        text-align: start;
        margin-bottom: 0;
        margin-left: 20px;
      }
    }
  }
  &__subs-advise {
    #{$this}__wrapper {
      display: flex;
      align-items: center;
      font-size: rem(16px);
    }
    display: flex;
    width: calc(100% + 40px);
    color: var(--white);
    background: var(--glass-mid-gray);
    margin-left: -20px;
    margin-top: -15px;
    @include mobile {
      margin-left: -50px;
      width: calc(100% + 100px);
    }
    @include desktop {
      margin-left: -220px;
      width: 100vw;
      padding: 0 100px;
    }
  }
  &__feature {
    padding-top: 10px;
    @include mobile {
      padding-top: 97.5px;
    }
  }
}
</style>
